// GERADO de backend-senne/src/contracts — NÃO editar; rode scripts/sync-contracts.sh

import { z } from 'zod'

/**
 * The internal doctor's form answers kept by the core (spec 20261026-142400, D2/D3): the inputs whose
 * `data_destination` is `Tasy` in the form catalogue. The inputs whose destination is `MySQL` keep their own routes
 * (`/internal-doctors/:userId/complement`).
 */
export const INTERNAL_DOCTOR_ANSWER_MAX_LENGTH = 1000

/** A select answer resolved to the catalogue option the form shows. */
export const internalDoctorAnswerOptionSchema = z.object({
    id: z.number(),
    label: z.string(),
    value: z.string(),
})

/** GET /internal-doctors/:userId?currentPage=n, inside the `data` envelope: input code → answer. */
export const internalDoctorAnswersResponseSchema = z.object({
    items: z.record(z.union([z.string(), internalDoctorAnswerOptionSchema])),
})
export type InternalDoctorAnswersResponse = z.infer<
    typeof internalDoctorAnswersResponseSchema
>

/** One answer as the form sends it: text, a number, a flag, or `null`/`''` to clear it. */
export const internalDoctorAnswerValueSchema = z.union([
    z.string().max(INTERNAL_DOCTOR_ANSWER_MAX_LENGTH),
    z.number().finite(),
    z.boolean(),
    z.null(),
])

/**
 * PUT /internal-doctors/tasy. The screen sends the whole page — the person `id` and every input code of the page,
 * including the `MySQL` ones, which the route ignores — so unknown keys pass here and only the Tasy codes are read,
 * each checked against `internalDoctorAnswerValueSchema`.
 */
export const saveInternalDoctorAnswersBodySchema = z
    .object({ id: z.coerce.number().int().positive() })
    .passthrough()
export type SaveInternalDoctorAnswersBody = z.infer<
    typeof saveInternalDoctorAnswersBodySchema
>

/** The PUT's `data`: how many answers were written. */
export const saveInternalDoctorAnswersResponseSchema = z.object({
    saved: z.number().int().nonnegative(),
})
export type SaveInternalDoctorAnswersResponse = z.infer<
    typeof saveInternalDoctorAnswersResponseSchema
>
